import Vue from 'vue'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective)
